document.addEventListener("DOMContentLoaded", function () {
    // Handle main menu click (toggle submenu)
    document.querySelectorAll(".menu-drawer__list-item--flat")
      .forEach(function (listItem) {
  
        const link = listItem.querySelector("a.menu-drawer__menu-item--mainlist");
        const submenu = listItem.querySelector(":scope > .menu-drawer__menu--childlist");
  
        if (!link || !submenu) return;
  
        link.addEventListener("click", function (e) {
          e.preventDefault();
  
          const isActive = listItem.classList.contains("menu-active");
  
          if (isActive) {
            listItem.classList.remove("menu-active");
            submenu.classList.remove("active");
          } else {
            // close other open submenus
            document.querySelectorAll(".menu-active").forEach(function (el) {
              if (el !== listItem) {
                el.classList.remove("menu-active");
                const activeChild = el.querySelector(".menu-drawer__menu--childlist.active");
                if (activeChild) activeChild.classList.remove("active");
              }
            });
  
            listItem.classList.add("menu-active");
            submenu.classList.add("active");
          }
        });
      });
  
    // Back button inside submenu
    document.querySelectorAll(".nav-back-button").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
  
        const currentDrawer = btn.closest(".menu-drawer__menu--childlist");
        if (!currentDrawer) return;
  
        const parentItem = currentDrawer.closest(".menu-drawer__list-item--flat");
  
        if (parentItem) parentItem.classList.remove("menu-active");
        currentDrawer.classList.remove("active");
      });
    });
  
    // Close button (close all menus)
    document.querySelectorAll(".menu-drawer__close-button").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
  
        document.querySelectorAll(".menu-drawer__list-item--flat.menu-active")
          .forEach(el => el.classList.remove("menu-active"));
  
        document.querySelectorAll(".menu-drawer__menu--childlist.active")
          .forEach(el => el.classList.remove("active"));
      });
    });
  });